export default "__VITE_ASSET__Dq8bvZ_t__"